export default __webpack_public_path__ + "static/media/SeaLife_28.09fe8664.png";